import {
    get,
    post
} from '../units/request'
let apiFun = [];
let url = 'http://192.168.1.20:8082/api/'
apiFun.postRegistrationUser = p => post(url + 'LoginService/RegistrationUser', p) //注册
apiFun.postLogin = p => post(url + 'LoginService/Login', p) //登录
apiFun.postHardwareGroup = p => post(url + 'DataSet/HardwareGroup', p) //添加、修改设备组
apiFun.getDelHardwareGroup = p => get(url + 'DataSet/DelHardwareGroup', p) //删除设备组
apiFun.getSelectHardwareGroup = p => get(url + 'DataSet/SelectHardwareGroup', p) //查询设备组列表
apiFun.getSelectHW = p => get(url + 'DataSet/SelectHW', p) //查询组内设备列表
apiFun.getPing = p => get(url + 'DataSet/Ping', p) //IP是否可以ping通
apiFun.postHWInfo = p => post(url + 'DataSet/HWInfo', p) //添加、修改设备信息
apiFun.postDelHW = p => post(url + 'DataSet/DelHW', p) //删除设备
apiFun.postSelectHWInfo = p => post(url + 'DataSet/SelectHWInfo', p) //查询设备信息
apiFun.postWebservice = p => post(url + 'DataSet/Webservice', p) //调用接口
apiFun.getSelcetMonitors = p => get(url + 'DataSet/SelcetMonitors', p) //查询监控地址
apiFun.postInUpMonitors = p => post(url + 'DataSet/InUpMonitors', p) //添加监控
apiFun.getSelcetMonitors = p => get(url + 'DataSet/SelcetMonitors', p) //查询监控列表
apiFun.getDelMonitors = p => get(url + 'DataSet/DelMonitors', p) //删除监控
export default apiFun;